import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  dataPixRefund: [],
  errorPixRefund: false,
  errorLoadingPixRefund: false,
  errorMessagePixRefund: '',
  loadingPixRefund: false,
  paginationPixRefund: {},
  detailsPixRefund: {},
  loadingDetailsPixRefund: false,
  messageDetailsPixRefund: '',
  successDetailsPixRefund: false,
  typeParticipants: [],
  typeStatusRefund: [],
};

export const pixRefundActionLoading = createAction('PIX_REFUND_ACTION_LOADING');
export const pixRefundActionSuccess = createAction('PIX_REFUND_ACTION_SUCCESS');
export const pixRefundActionError   = createAction('PIX_REFUND_ACTION_ERROR');

export const detailsPixRefundActionLoading = createAction('DETAILS_PIX_REFUND_ACTION_LOADING');
export const detailsPixRefundActionSuccess = createAction('DETAILS_PIX_REFUND_ACTION_SUCCESS');
export const detailsPixRefundActionError   = createAction('DETAILS_PIX_REFUND_ACTION_ERROR');

export const typeParticipantsSuccess = createAction('TYPE_PARTICIPANTS_ACTION_SUCCESS');
export const typeParticipantsError   = createAction('TYPE_PARTICIPANTS_ACTION_ERROR');

export const typeStatusRefundSuccess = createAction('TYPE_STATUS_REFUND_ACTION_SUCCESS');
export const typeStatusRefundError = createAction('TYPE_STATUS_REFUND_ACTION_ERROR');

export const createRefundSuccess = createAction('CREATE_REFUND_ACTION_SUCCESS');
export const createRefundError = createAction('CREATE_REFUND_ACTION_ERROR');
export const createRefundLoading = createAction('CREATE_REFUND_ACTION_LOADING');

export default createReducer(INITIAL_STATE, {
  [pixRefundActionLoading.type]: (state) => {
    return {
      ...state,
      loadingPixRefund: true,
      errorPixRefund: false,
    };
  },
  [pixRefundActionSuccess.type]: (state, payload) => {
    const { data, pagination } = payload?.payload?.data;

    return {
      ...state,
      loadingPixRefund: false,
      errorPixRefund: false,
      dataPixRefund: data,
      paginationPixRefund: pagination,
    };
  },
  [pixRefundActionError.type]: (state, payload) => {
    return {
      ...state,
      loadingPixRefund: false,
      errorPixRefund: true,
      errorMessagePixRefund: payload?.mensagem,
      dataPixRefund: [],
      paginationPixRefund: {},
    };
  },
  [detailsPixRefundActionLoading.type]: (state) => {
    return {
      ...state,
      loadingDetailsPixRefund: true,
    };
  },
  [detailsPixRefundActionSuccess.type]: (state, payload) => {
    const { data, mensagem } = payload?.payload?.data;

    return {
      ...state,
      loadingDetailsPixRefund: false,
      detailsPixRefund: data,
      messageDetailsPixRefund: mensagem,
      successDetailsPixRefund: true,
    };
  },
  [detailsPixRefundActionError.type]: (state, payload) => {
    return {
      ...state,
      loadingDetailsPixRefund: false,
      detailsPixRefund: [],
      messageDetailsPixRefund: payload?.mensagem,
      successDetailsPixRefund: false,
    };
  },
  [typeParticipantsSuccess.type]: (state, payload) => {
    const { data, mensagem } = payload?.payload?.data;

    return {
      ...state,
      loadingDetailsPixRefund: false,
      typeParticipants: data,
      messageDetailsPixRefund: mensagem,
      successDetailsPixRefund: true,
    };
  },
  [typeParticipantsError.type]: (state, payload) => {
    return {
      ...state,
      loadingPixRefund: false,
      errorPixRefund: true,
      errorMessagePixRefund: payload?.mensagem,
      typeParticipants: [],
      paginationPixRefund: {},
    };
  },
  [typeStatusRefundSuccess.type]: (state, payload) => {
    const { data, mensagem } = payload?.payload?.data;

    return {
      ...state,
      loadingDetailsPixRefund: false,
      typeStatusRefund: data,
      messageDetailsPixRefund: mensagem,
      successDetailsPixRefund: true,
    };
  },
  [typeStatusRefundError.type]: (state, payload) => {
    return {
      ...state,
      loadingPixRefund: false,
      errorPixRefund: true,
      errorMessagePixRefund: payload?.mensagem,
      typeStatusRefund: [],
      paginationPixRefund: {},
    };
  },
  [createRefundLoading.type]: (state) => {
    return {
      ...state,
      loadingPixRefund: true,
    };
  },
  [createRefundSuccess.type]: (state, payload) => {
    return {
      ...state,
      loadingPixRefund: false,
      errorPixRefund: false,
    };
  },
  [createRefundError.type]: (state, payload) => {
    return {
      ...state,
      loadingPixRefund: false,
      errorPixRefund: true,
      errorMessagePixRefund: payload?.payload?.mensagem,
    };
  },
});
